import { atomWithStorage } from "jotai/utils";
import { STORAGE_STICKY_NOTE_OPEN } from "utils/constants";

export const stickyNoteOpenAtom = atomWithStorage(
	STORAGE_STICKY_NOTE_OPEN,
	false
);
